import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './inventoryList.html'

/**
 * Inventory.
 *
 * @namespace routes.OperationInventoryList
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.inventory.list',
  label: 'OPERATIONS.INVENTORY.TITLE',
  url: '/inventory',
  params: {
    closed: 'false',
  },
  resourceType: 'Inventory',
  resourceList: {
    searchParameters: ['creationDate.from', 'creationDate.to', 'place.id'],
    hiddenSearchParameters: ['closed'],
  },
  component: 'tmrOperationInventory',
  accessControl: ['Operation.perform', 'Operation.Inventory.perform'],
  mainMenu: false,
}

/**
 * Inventory component.
 *
 * @type {ngComponent}
 */
export const tmrOperationInventory = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
  controller: 'tmrOperationInventoryController',
}

/**
 * Controller of component {@link tmrOperationInventoryController}.
 *
 * @type {ngController}
 */
export class tmrOperationInventoryController {
  static ngType = 'controller'

  constructor($state, TmrPromptModal, TmrToast, MovementInventoryConfirmation) {
    'ngInject'
    Object.assign(this, {
      $state,
      TmrPromptModal,
      TmrToast,
      MovementInventoryConfirmation,
    })
  }

  askCloseInventory($event, inventory) {
    this.TmrPromptModal($event, {
      question: 'OPERATIONS.INVENTORY.CLOSEQUESTION',
      yesCallback: () => this.closeInventory(inventory),
      relativeTo: `.close-inventory-${inventory.id}`,
      icon: 'o-lock-1',
    })
  }

  closeInventory(inventory) {
    this.closing = true
    this.MovementInventoryConfirmation.create({ inventory })
      .$save()
      .then(() => this.$state.reload())
      .then(
        () => this.TmrToast.success('OPERATIONS.INVENTORY.CLOSETOAST'),
        err => this.TmrToast.exception(err)
      )
      .finally(() => (this.closing = false))
  }
}
